import axios from 'axios';
import { Config } from 'config';
import { IStoreLocation } from './StoreLocator.types';
import { IShipping } from '../../../types/Shipping';

const StoreLocatorUrl = `${Config.url.STORE_URL}/api/v1/Location`;
const ShippingUrl = `${Config.url.STORE_URL}/api/v1/Shipping`;

const SearchStores = (
    search: string,
    onSuccess: (responseData: IStoreLocation[]) => void,
    onFailure: () => void,
    useDefault?: boolean
) => {
    axios
        .get(`${StoreLocatorUrl}/${search}${useDefault ? '?useDefault=true' : '?useDefault=false'}`)
        .then((response) => {
            let data = response.data as IStoreLocation[];
            data = data.filter((x) => x.isVisible);
            onSuccess(data);
        }, onFailure);
};

const FindPostOffices = (
    search: string,
    onSuccess: (responseData: IStoreLocation[]) => void,
    onFailure: () => void
) => {
    axios.get(`${StoreLocatorUrl}/post-office/${search}`).then((response) => {
        onSuccess(response.data);
    }, onFailure);
};

const GetShippingCosts = (onSuccess: (responseData: IShipping) => void, onFailure: () => void) => {
    axios.get(`${ShippingUrl}`).then((response) => {
        onSuccess(response.data);
    }, onFailure);
};

export default { SearchStores, FindPostOffices, GetShippingCosts };
